interface AgeSliderProps {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
  ariaLabel?: string;
}

export function AgeSlider({
  value,
  onChange,
  min = 0,
  max = 99,
  ariaLabel = 'Age',
}: AgeSliderProps) {
  const display = value === 0 ? 'Infant' : String(value);

  return (
    <div className="flex items-center gap-3 min-h-[44px] w-full">
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        aria-label={ariaLabel}
        aria-valuetext={display}
        className="age-slider"
        style={{ flex: 1, accentColor: 'var(--accent)', minWidth: 0 }}
      />
      <span
        aria-hidden="true"
        style={{
          minWidth: 56,
          textAlign: 'center',
          color: 'var(--ink)',
          fontSize: 14,
          fontWeight: 500,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {display}
      </span>
    </div>
  );
}
